export const formatCurrency = (value: any) => {
  if (!value) return '';

  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
  });
  return formatter
    .format(value / 100)
    .replaceAll(".", "")
    .replaceAll(",", ".");
};

export const parseCurrency = (value: string) => {
  return parseFloat(value.replace(/\./g, '').replace(',', '.'));
  ;
}

export const formatErrorMessage = (value: string) => {
  if (value === '{"message":"  20 -  Transação já cancelada "}') {
    return 'Transação já cancelada';
  } else if (value === '{"message":"transaction not found"}') {
    return 'Transação não encontrada';
  } else if (value === '{"message":"  21 -  O valor do cancelamento excede o disponível. "}') {
    return 'O valor do cancelamento excede o disponível';
  }

  // Fora dos casos conhecidos, aproveita a mensagem que veio da API em vez de
  // descartá-la: a comparação acima é por string exata, então qualquer variação
  // (espaço, código novo) caía em "Erro não identificado" e escondia a causa.
  return extractApiMessage(value) ?? 'Erro não identificado';
};

const extractApiMessage = (value: unknown): string | null => {
  if (!value) return null;

  if (typeof value === 'object') {
    const message = (value as { message?: unknown }).message;
    return typeof message === 'string' && message.trim() ? message.trim() : null;
  }

  if (typeof value !== 'string') return null;

  try {
    const parsed = JSON.parse(value);
    const message = parsed?.message;
    return typeof message === 'string' && message.trim() ? message.trim() : null;
  } catch {
    // Não era JSON — texto puro já serve como mensagem.
    return value.trim() ? value.trim() : null;
  }
};
